var React = require('react');

function PrevArrowResource (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Path_651","data-name":"Path 651","d":"M719.169,328.911l-1.748,1.877,7.875,7.321H703.2v2.563H725.3L717.421,348l1.748,1.877,11.272-10.479Z","transform":"translate(730.441 349.872) rotate(180)","fill":"#fff"}));
}

PrevArrowResource.defaultProps = {"width":"27.246","height":"20.961","viewBox":"0 0 27.246 20.961"};

module.exports = PrevArrowResource;

PrevArrowResource.default = PrevArrowResource;
